import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { startCase, lowerCase, upperCase, trim, isArray } from 'lodash';
import {
  Layout,
  Dropdown,
  Menu,
  Row,
  Col,
  Button,
  Avatar,
  Spin,
  Tooltip,
  Divider,
  Modal,
  Result,
} from 'antd';
import {
  TeamOutlined,
  UserOutlined,
  LogoutOutlined,
  BarsOutlined,
} from '@ant-design/icons';
import { get } from 'lodash';
import { NavLink } from 'react-router-dom';
import { Menus } from './Menus';

import SideMenu from './SideMenu';
import ContentBody from './ContentBody';
import {
  UserAgreementHtmlContent,
  PrivacyPolicyHtmlContent,
} from './PoliciesHtmlContent';
import ProfileSelectionModal from '../login/ProfileSelectionModal';
import {
  readActiveProfile,
  writeActiveProfile,
  getOktaAuthTime,
} from './profileSelectionUtils';

import {
  GET_GROWER_PROFILE,
  SA_PROFILE,
  APP_HOME,
  SA_DASHBOARD,
  SR_DASHBOARD,
  DASHBOARD,
  ADMIN_BULLETIN,
  CSA_DASHBOARD,
  SR_PROFILE,
  CSA_PROFILE,
  APP_GROWER_LOGIN,
} from '../constants/RouteConstants';
import { USER_TYPES } from '../constants/ApplicationConstants';
//import { applicationSteps } from '../grower/profileAndApplication/utilities';
import {
  getUserTypeFromUrl,
  dataLayer,
  isGrowerInactive,
} from '../utilities/UtilityFunctions';
import FinancialYearSelector from '../shared/components/financialYearSelector/FinancialYearSelectorContainer';
import logo from '../../client/images/logo-horizontal.png';
import notification from '../../client/images/notifications.svg';
import { RightOutlined, LeftOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import { isEmpty } from 'lodash';
import IdleTimer from 'react-idle-timer';
import IdleTimeOutModal from './IdleTimeOutModal';
import NoticeModal from './NoticeModal';
import './landing.less';
import '../login/ProfileSelectionModal/profile-selection-modal.less';
import { getEnvironmentValue, SALES_YEAR_CONFIG } from '../../envConfig';
import CookieConsent from '../common/CookieConsent/CookieConsent';
import CookieInfo from '../common/CookieConsent/CookieInfo';
import { getUserIdleTimeoutDuration } from './user-idle-timeout';
import { addUserIdentification } from '../utilities/smartlook';
import { setAnalyticsUser, trackPageView } from '../utilities/analytics';
import { getCreditDetOfGrower } from '../grower/profile/common';
import { ErrorDialog, SuccessDialog } from '../grower/make-a-payment/utils';

// get-user-profile error code: the email only has Inactive / deleted contacts.
const INACTIVE_CONTACT_ERROR = 'inactive_contact';

class Landing extends Component {
  constructor(props) {
    super(props);
    this.loadUserType = undefined;
    this.showNtc = false;
    this.state = {
      isSiderCollapsed: false,
      isHeaderMenuVisible: false,
      showModal: false,
      showNoticeModal: false,
      agreeClk: false,
      policyClk: false,
      saClicked: false,
      growerClicked: false,
      agreementLinkClicked: false,
      policyLinkClicked: false,
      userLoggedIn: false,
      isTimedOut: false,
      currentUsertype: 'user',
      showCookie: false,
      showSuccessDialog: false,
      smallScreen: window.matchMedia('(max-width: 500px)').matches,
      showProfileSelectionModal: false,
      profileSelectionChecked: false,
      selectedProfileType: null, // Stores the user-selected profile type
      showSwitchProfilesModal: false,
      // Login found the email only on Inactive / deleted contacts.
      inactiveContact: false,
    };

    this._isMounted = false;
    this._mediaWatcher = null;
    this._mediaHandler = null;
    this._noticeTimeout = null;
    this.idleTimer = null;
    this.onAction = this._onAction.bind(this);
    this.onActive = this._onActive.bind(this);
    this.onIdle = this._onIdle.bind(this);
    this.openCookiePolicy = this.openCookiePolicy.bind(this);
    this.closeCookiePolicy = this.closeCookiePolicy.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleNoticeClose = this.handleNoticeClose.bind(this);
    this.handlepolicyClick = this.handlepolicyClick.bind(this);
    this.handleagrrementClick = this.handleagrrementClick.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
    this.handleAgreeLink = this.handleAgreeLink.bind(this);
    this.handlePolicyLink = this.handlePolicyLink.bind(this);
  }

  _onAction(e) {
    this.setState({ isTimedOut: false });
  }

  _onActive(e) {
    this.setState({ isTimedOut: false });
  }

  _onIdle(e) {
    const userTimedOut = this.state.isTimedOut;
    if (userTimedOut) {
      this.props.logoutUser();
      this.props.history.push(APP_GROWER_LOGIN);
    } else {
      this.setState({ showModal: true });
      this.idleTimer.reset();
      this.setState({ isTimedOut: true });
    }
  }

  handleClose() {
    this.setState({ showModal: false });
  }

  handleNoticeClose() {
    this.setState({ showModal: false });
    // this.setState({ showNoticeModal: false });
    this.showNtc = false;
    const { updateNotificationStatus } = this.props;
    let userDetails = JSON.parse(sessionStorage.getItem('userInfo'));
    userDetails['is_agreements_agreed'] = true;
    this.props.aggreeClick();

    if (userDetails.userType === 'SEED_ADVISOR') {
      this.setState({ saClicked: true });
    } else if (userDetails.userType === 'GROWER') {
      this.setState({ growerClicked: true });
    }
    if (userDetails.userType === 'GROWER' && userDetails.step !== undefined) {
      delete userDetails.step;
    }
    sessionStorage.setItem('userInfo', JSON.stringify(userDetails));
    this.setState({ agreeClk: false });
    this.setState({ policyClk: false });

    updateNotificationStatus(userDetails);
    this._noticeTimeout = setTimeout(() => {
      window.location.reload();
    }, 1000);
  }

  handleAgreeLink() {
    this.setState({ agreementLinkClicked: true });
  }

  handlepolicyClick() {
    this.setState({ policyClk: true });
    Modal.info({
      title: 'Privacy Policy',
      width: '80%', // Adjust the width as needed
      content: (
        <div style={{ maxHeight: '70vh', overflowY: 'auto' }}>
          <div
            dangerouslySetInnerHTML={{
              __html: PrivacyPolicyHtmlContent,
            }}
          />
        </div>
      ),
      onOk() {},
    });
  }

  handleagrrementClick() {
    this.setState({ agreeClk: true });
    Modal.info({
      title: 'User Agreement',
      width: '80%', // Adjust the width as needed
      content: (
        <div style={{ maxHeight: '70vh', overflowY: 'auto' }}>
          <div
            dangerouslySetInnerHTML={{
              __html: UserAgreementHtmlContent,
            }}
          />
        </div>
      ),
      onOk() {},
    });
  }

  handlePolicyLink() {
    this.setState({ policyLinkClicked: true });
  }

  openCookiePolicy() {
    this.setState({ showCookie: true });
  }

  closeCookiePolicy() {
    this.setState({ showCookie: false });
  }

  handleLogout() {
    this.setState({ showModal: false });
    this.props.logoutUser();
    this.props.history.push(APP_GROWER_LOGIN);
  }

  async componentDidMount() {
    this._isMounted = true;
    this._mediaHandler = (e) => {
      if (this._isMounted) {
        this.setState({ smallScreen: e.matches });
      }
    };
    this._mediaWatcher = window.matchMedia('(max-width: 500px)');
    if (this._mediaWatcher.addEventListener) {
      this._mediaWatcher.addEventListener('change', this._mediaHandler);
    } else {
      this._mediaWatcher.addListener(this._mediaHandler);
    }
    if (isEmpty(this.props.session)) {
      const session = await this.props.oktaAuth.getUser();
      if (!this._isMounted) return;
      if (session) {
        const accessToken = this.props.oktaAuth.getAccessToken();
        session.accessToken = accessToken;
        const { email } = session;
        addUserIdentification(email);
        setAnalyticsUser({
          email,
          oktaSub: session.sub,
        });
        this.props.setSession(session);
        // Load user profiles to check if profile selection is needed
        this.props.loadUserProfiles(email, this.handleProfilesError);
      } else {
        this.props.logoutUser();
      }
    } else if (
      !this.state.profileSelectionChecked &&
      this.props.userProfiles.length === 0
    ) {
      // Check if we need to load profiles for profile selection
      this.props.loadUserProfiles(
        this.props.sessionEmail,
        this.handleProfilesError
      );
    } else {
      this.checkProfileSelectionNeeded();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    // Clean up media query listener
    if (this._mediaWatcher && this._mediaHandler) {
      if (this._mediaWatcher.removeEventListener) {
        this._mediaWatcher.removeEventListener('change', this._mediaHandler);
      } else {
        this._mediaWatcher.removeListener(this._mediaHandler);
      }
    }
    // Clear any pending timeout
    if (this._noticeTimeout) {
      clearTimeout(this._noticeTimeout);
    }
  }

  // The profiles lookup failed. An inactive contact cannot sign in at all, so
  // stop here and explain it; anything else keeps the default flow.
  handleProfilesError = (errResp) => {
    if (errResp?.errorMsg === INACTIVE_CONTACT_ERROR && this._isMounted) {
      this.setState({ inactiveContact: true });
    }
  };

  checkProfileSelectionNeeded = async () => {
    if (!this._isMounted || this.state.inactiveContact) return;
    const { userProfiles, defaultProfileId, oktaAuth } = this.props;

    // Mark that we've checked profile selection
    if (!this.state.profileSelectionChecked) {
      this.setState({ profileSelectionChecked: true });
    }

    // If profiles API failed or returned empty, fallback to original behavior
    if (!userProfiles || userProfiles.length === 0) {
      console.log(
        '[ProfileSelection] No profiles available, using original flow'
      );
      this.loadUserDetail();
      return;
    }

    console.log(
      '[ProfileSelection] Profiles loaded:',
      userProfiles.length,
      'defaultProfileId:',
      defaultProfileId
    );

    // If only one profile, load directly
    if (userProfiles.length === 1) {
      const profile = userProfiles[0];
      console.log(
        '[ProfileSelection] Single profile, using:',
        profile.accountType
      );
      this.redirectToProfile(profile);
      return;
    }

    // Priority 1: resume the active profile, but only within the same login
    // session. Unavailable auth_time / no stored profile is treated as a fresh
    // login, so resume is skipped and we fall through to default/picker.
    const authTime = await getOktaAuthTime(oktaAuth);
    if (!this._isMounted) return;
    const stored = authTime ? readActiveProfile() : null;
    if (stored && stored.authTime === authTime) {
      const activeProfile = userProfiles.find((p) => p.id === stored.profileId);
      if (activeProfile) {
        console.log(
          '[ProfileSelection] Resuming active profile:',
          activeProfile.accountType
        );
        this.redirectToProfile(activeProfile);
        return;
      }
    }

    // Priority 2: default profile.
    if (defaultProfileId) {
      const defaultProfile = userProfiles.find(
        (p) => String(p.id) === String(defaultProfileId)
      );
      if (defaultProfile) {
        console.log(
          '[ProfileSelection] Default profile found, redirecting:',
          defaultProfile.accountType
        );
        this.redirectToProfile(defaultProfile);
        return;
      }
      console.log(
        '[ProfileSelection] Default profile not found in available profiles, showing modal'
      );
    }

    // Priority 3: show the selection modal
    console.log('[ProfileSelection] Showing profile selection modal');
    this.setState({ showProfileSelectionModal: true });
  };

  redirectToProfile = (profile, { preserveLocation = true } = {}) => {
    if (!this._isMounted) return;
    const { history } = this.props;
    const profileTypeUrlMap = {
      GROWER: DASHBOARD,
      SEED_ADVISOR: SA_DASHBOARD,
      SALES_REPRESENTATIVE: SR_DASHBOARD,
      ADMINISTRATOR: ADMIN_BULLETIN,
      CUSTOMER_SUPPORT: CSA_DASHBOARD,
    };
    const profileTypeBaseUrlMap = {
      GROWER: '/grower',
      SEED_ADVISOR: '/seed-advisor',
      SALES_REPRESENTATIVE: '/sales-representative',
      ADMINISTRATOR: '/administrator',
      CUSTOMER_SUPPORT: '/customer-support',
    };
    const targetPath = profileTypeUrlMap[profile.accountType];
    const baseUrl = profileTypeBaseUrlMap[profile.accountType];
    const alreadyOnProfilePage =
      history.location.pathname.indexOf(baseUrl) === 0;

    this.persistActiveProfile(profile);
    this.setState({ selectedProfileType: profile.accountType }, () => {
      if (!(preserveLocation && alreadyOnProfilePage)) {
        history.push(targetPath);
      }
      this.loadUserDetailWithType(profile.accountType, profile);
    });
  };

  persistActiveProfile = async (profile) => {
    if (!profile?.id) return;
    const authTime = await getOktaAuthTime(this.props.oktaAuth);
    writeActiveProfile(profile.id, authTime);
  };

  handleProfileSelection = (profile, setAsDefault) => {
    if (!this._isMounted) return;
    // Call the onSelectProfile from props to handle state and cookie saving
    this.props.onSelectProfile(profile, setAsDefault);

    console.log(
      '[ProfileSelection] Selected profile type:',
      profile.accountType,
      'setAsDefault:',
      setAsDefault
    );

    // Close modal and redirect to selected profile
    this.setState({ showProfileSelectionModal: false }, () => {
      this.redirectToProfile(profile, { preserveLocation: false });
    });
  };

  loadUserDetailWithType = (userType, profile = {}) => {
    // Load user details with a specific user type
    console.log(
      '[ProfileSelection] loadUserDetailWithType called with:',
      userType
    );
    console.log(
      '[ProfileSelection] Current state.selectedProfileType:',
      this.state.selectedProfileType
    );
    console.log('[ProfileSelection] sessionEmail:', this.props.sessionEmail);

    this.props.loadUserDetail(
      this.props.sessionEmail,
      userType,
      window.localStorage.getItem('seed-advisor-id') || '',
      window.localStorage.getItem('zd-partnership-uuid'),
      profile.salesForceId || ''
    );
  };

  loadUserDetail = () => {
    // Skip if we're in the middle of profile selection (selectedProfileType is set)
    if (this.state.selectedProfileType) {
      console.log(
        '[ProfileSelection] Skipping loadUserDetail - using selected profile type'
      );
      return;
    }

    // Use stored intended user type if available (from login flow), otherwise fall back to URL
    const intendedUserType = sessionStorage.getItem('intendedUserType');
    const userTypeToUse =
      this.loadUserType || intendedUserType || getUserTypeFromUrl();

    this.props.loadUserDetail(
      this.props.sessionEmail,
      userTypeToUse,
      window.localStorage.getItem('seed-advisor-id') || '',
      window.localStorage.getItem('zd-partnership-uuid')
    );
    this.loadUserType = undefined;

    // Clear the stored intended user type after using it
    if (intendedUserType) {
      sessionStorage.removeItem('intendedUserType');
    }
  };

  componentDidUpdate(prevProps) {
    const { user, menuItems, session, history, location, profilesLoading } =
      this.props;

    if (user && user !== prevProps.user) {
      setAnalyticsUser({
        uuid: user.uuid,
        id: user.id,
        email: this.props.sessionEmail,
        userType: user.userType,
        grower_id: user.grower_id,
      });
    }

    if (location.pathname !== prevProps.location.pathname) {
      trackPageView({
        route: location.pathname,
        user_type: user ? user.userType : 'session',
      });
    }

    if (
      user &&
      this.state.selectedProfileType &&
      user.userType !== prevProps.user?.userType
    ) {
      console.log(
        '[ProfileSelection] User loaded, clearing selectedProfileType'
      );
      this.setState({ selectedProfileType: null });
    }

    // Check if profiles were just loaded (loading finished)
    if (
      !profilesLoading &&
      prevProps.profilesLoading &&
      !this.state.profileSelectionChecked
    ) {
      this.checkProfileSelectionNeeded();
      return; // Exit early to let the profile selection logic handle the rest
    }

    if (this.props.status === 'ACCEPTED' && !prevProps.showSuccessDialog) {
      this.setState({ showSuccessDialog: true });
    } else if (
      this.props.status &&
      this.props.status !== 'ACCEPTED' &&
      !prevProps.showErrorDialog
    ) {
      this.setState({ showErrorDialog: true });
    }

    if (
      user?.is_agreements_agreed !== undefined &&
      !user?.is_agreements_agreed
    ) {
      this.showNtc = true;
    }
    let userDetails = JSON.parse(sessionStorage.getItem('userInfo'));
    if (
      userDetails?.is_agreements_agreed !== undefined &&
      !userDetails?.is_agreements_agreed
    ) {
      this.showNtc = true;
    } else {
      this.showNtc = false;
    }

    if (
      userDetails?.userType === 'GROWER' &&
      userDetails?.grower_seed_advisors?.length === 0
    ) {
      this.showNtc = false;
    }

    // if (
    //   userDetails?.userType === 'GROWER' &&
    //   userDetails?.grower_seed_advisors?.length > 0 &&
    //   userDetails.step !== undefined &&
    //   userDetails.step === applicationSteps.CONFIRMATION
    // ) {
    //   this.showNtc = true;
    // }

    // Don't auto-load user if:
    // 1. Profiles are still loading (waiting to check if profile selection is needed)
    // 2. Profile selection modal is showing
    // 3. Profile was just selected (selectedProfileType is set)
    // 4. Profile selection check hasn't completed yet
    const shouldSkipAutoLoad =
      profilesLoading ||
      this.state.showProfileSelectionModal ||
      this.state.selectedProfileType ||
      !this.state.profileSelectionChecked;

    if (
      session &&
      ((!user && !prevProps.session) || (prevProps.user && !user)) &&
      !shouldSkipAutoLoad
    ) {
      this.loadUserDetail();
    } else if (
      user &&
      menuItems.length > 0 &&
      APP_HOME === get(history, 'location.pathname', APP_HOME)
    ) {
      if (user.isProfileComplete) {
        history.push(menuItems[0].navLink);
      } else {
        let targetUrl;
        switch (user.userType) {
          case USER_TYPES.ADMIN:
            targetUrl = ADMIN_BULLETIN;
            break;
          case USER_TYPES.SEED_ADVISOR:
            targetUrl = SA_PROFILE;
            break;
          default:
            targetUrl = DASHBOARD;
            break;
        }
        history.push(targetUrl);
      }
    } else if (
      user &&
      menuItems.length &&
      !this.state.selectedProfileType && // Skip redirect if profile was just selected
      location.pathname.indexOf(this.checkAccessURL()) === -1
    ) {
      console.log('[ProfileSelection] Redirecting - path mismatch:', {
        currentPath: location.pathname,
        expectedBase: this.checkAccessURL(),
        userType: user.userType,
        redirectTo: menuItems[0].navLink,
      });
      history.push(menuItems[0].navLink);
    }
    dataLayer.push({
      event: 'PageView',
      path: '/landing',
      userType: user ? user.userType : 'session',
    });
  }

  getUserProfileURL = () => {
    const { user } = this.props;
    const returnURL =
      USER_TYPES.GROWER === user.userType
        ? GET_GROWER_PROFILE()
        : USER_TYPES.SALES_REPRESENTATIVE === user.userType
        ? SR_PROFILE
        : USER_TYPES.CUST_SUPPORT_ADMIN === user.userType
        ? CSA_PROFILE
        : USER_TYPES.SEED_ADVISOR === user.userType
        ? SA_PROFILE
        : CSA_PROFILE;
    return returnURL;
  };
  navigateToProfile = () => {
    const { history } = this.props;
    const targetUrl = this.getUserProfileURL();
    history.push(targetUrl);
  };

  openSwitchProfilesModal = () => {
    this.setState({ showSwitchProfilesModal: true });
  };

  closeSwitchProfilesModal = () => {
    this.setState({ showSwitchProfilesModal: false });
  };

  handleSwitchProfileSelection = (profile, setAsDefault) => {
    if (!this._isMounted) return;
    const { setUserProfile } = this.props;
    this.props.onSelectProfile(profile, setAsDefault);

    this.loadUserType = profile.accountType;
    this.setState(
      {
        selectedProfileType: profile.accountType,
        showSwitchProfilesModal: false,
      },
      () => {
        setUserProfile(undefined);
        this.redirectToProfile(profile, { preserveLocation: false });
      }
    );
  };

  onNotificationsClick = () => {
    const { history, user } = this.props;
    if (user.userType === USER_TYPES.GROWER) {
      history.push('/grower/notifications');
    } else if (user.userType === USER_TYPES.SEED_ADVISOR) {
      history.push('/seed-advisor/notifications');
    } else if (user.userType === USER_TYPES.CUST_SUPPORT_ADMIN) {
      history.push('/customer-support/notifications');
    } else if (user.userType === USER_TYPES.SALES_REPRESENTATIVE) {
      history.push('/sales-representative/notifications');
    }
  };

  checkAccessURL() {
    const { user } = this.props;
    if (user.userType === USER_TYPES.GROWER) {
      return 'grower';
    } else if (user.userType === USER_TYPES.SEED_ADVISOR) {
      return 'seed-advisor';
    } else if (user.userType === USER_TYPES.CUST_SUPPORT_ADMIN) {
      return 'customer-support';
    } else if (user.userType === USER_TYPES.SALES_REPRESENTATIVE) {
      return 'sales-representative';
    } else if (user.userType === USER_TYPES.ADMIN) {
      return 'administrator';
    }
  }

  toggleCollapsed = () =>
    this.setState({ isSiderCollapsed: !this.state.isSiderCollapsed });

  toggleHeaderMenu = () =>
    this.setState({ isHeaderMenuVisible: !this.state.isHeaderMenuVisible });

  getSwitchProfilesMenuItem = () => {
    const { user, userProfiles, commonMessages } = this.props;
    const hasMultipleProfiles =
      (userProfiles && userProfiles.length > 1) ||
      (user && user.roles && user.roles.length > 1);

    if (user && user.userType && hasMultipleProfiles) {
      return (
        <Menu.Item
          key="switch-profiles"
          icon={<TeamOutlined />}
          onClick={this.openSwitchProfilesModal}
        >
          {commonMessages.switch_profiles}
        </Menu.Item>
      );
    }
  };

  profileNavLink = (userType) => {
    switch (userType) {
      case USER_TYPES.GROWER:
        return GET_GROWER_PROFILE();
      case USER_TYPES.SEED_ADVISOR:
        return SA_PROFILE;
      case USER_TYPES.CUST_SUPPORT_ADMIN:
        return CSA_PROFILE;
      default:
        return '';
    }
  };

  userMenu = () => {
    const { user, logoutUser, messages, sessionEmail: email } = this.props;
    const showEmail = !(trim(user.first_name) || trim(user.last_name));
    const initial = upperCase(
      showEmail
        ? `${email[0]}`
        : `${user.first_name[0]}${user.last_name ? user.last_name[0] : ''}`
    );

    return (
      <span>
        <Dropdown
          overlay={
            <Menu>
              <Menu.Item
                key="profile"
                icon={<UserOutlined />}
                onClick={this.navigateToProfile}
              >
                <NavLink to="">{messages.menu.profile}</NavLink>
              </Menu.Item>
              {this.getSwitchProfilesMenuItem()}
              <Menu.Item
                key="sign-out"
                icon={<LogoutOutlined />}
                onClick={logoutUser}
              >
                {messages.menu.sign_out}
              </Menu.Item>
            </Menu>
          }
        >
          <Button className="user-avtar-cnt">
            <Row gutter={6}>
              <Col>
                <Avatar>{initial}</Avatar>
              </Col>
              <Col>
                <p className="user-name">
                  {showEmail
                    ? email
                    : startCase(
                        lowerCase(
                          `${user.first_name} ${
                            user.last_name ? user.last_name : ''
                          }`
                        )
                      )}
                </p>
                <p className="user-type">
                  {this.getUserTypeValue(user.userType)}
                </p>
              </Col>
            </Row>
          </Button>
        </Dropdown>
      </span>
    );
  };

  headerMenu = () => {
    const { location, menuItems } = this.props;
    return (
      <Dropdown
        className="header-menu"
        visible={this.state.isHeaderMenuVisible}
        overlay={
          <Menus
            menuItems={menuItems}
            currPath={get(location, 'pathname', '')}
            toggleMenu={this.toggleHeaderMenu}
          />
        }
        trigger={['click']}
      >
        <Avatar
          size={48}
          icon={<BarsOutlined />}
          onClick={this.toggleHeaderMenu}
        />
      </Dropdown>
    );
  };

  footerContent = () => {
    const { messages } = this.props;
    return (
      <Row>
        <Col span={15}>
          <Row gutter={16}>
            <Col>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.syngenta-us.com/copyright.aspx"
              >
                {new Date().getFullYear()}©{' ' + messages.syngenta}
              </a>
              <Divider className="footer-divider" type="vertical" />
            </Col>
            <Col>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.syngenta-us.com/legal/useragreement.html"
              >
                {messages.user_agreement}
              </a>
              <Divider className="footer-divider" type="vertical" />
            </Col>
            <Col>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.syngenta-us.com/legal/privacypolicy.html"
              >
                {messages.online_privacy_policy}
              </a>
              <Divider className="footer-divider" type="vertical" />
            </Col>
            <Col>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.syngenta-us.com/legal/cookiepolicy.html"
              >
                {messages.cookie_policy}
              </a>
              <Divider className="footer-divider" type="vertical" />
            </Col>
            <Col>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.syngenta-us.com/legal/SMSpolicy.html"
              >
                {messages.sms_t_c}
              </a>
              <Divider className="footer-divider" type="vertical" />
            </Col>
            <Col>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.syngenta-us.com/legal/privacypolicy.html"
              >
                {messages.dont_sell}
              </a>
              <Divider className="footer-divider" type="vertical" />
            </Col>
            <Col>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.syngenta-us.com/legal/privacypolicy.html"
              >
                {messages.limit_sensitive_info}
              </a>
              <Divider className="footer-divider" type="vertical" />
            </Col>
          </Row>
        </Col>
        <Col span={9}>
          <Row gutter={{ xs: 8, sm: 16 }}>
            <Col>{messages.ga_support}</Col>
            <Col>
              <a href="mailto: support@goldenadvantage.com">
                {messages.support_email}
              </a>
              <Divider className="footer-divider" type="vertical" />
            </Col>
            <Col>{messages.support_phone}</Col>
          </Row>
        </Col>
      </Row>
    );
  };

  getUserTypeValue = (userType) => {
    const { smallScreen } = this.state;
    if (smallScreen) {
      const personaShortNameMapping = {
        ADMINISTRATOR: 'ADMIN',
        CUSTOMER_SUPPORT: 'CAS',
        GROWER: 'GROWER',
        SALES_REPRESENTATIVE: 'SALES REP',
        SEED_ADVISOR: 'SA',
      };
      return personaShortNameMapping[userType];
    }
    return userType?.replace('_', ' ');
  };

  getUserCurrTrans = (providedSalesYear, user) => {
    const { grower_credit_histories } = user || {};
    if (isArray(grower_credit_histories)) {
      const creditHistoryRecord = grower_credit_histories.filter(
        (creditHistory) => creditHistory.year === providedSalesYear
      );
      if (creditHistoryRecord.length > 0) {
        return getCreditDetOfGrower(grower_credit_histories, providedSalesYear);
      }
    }
    return null;
  };

  isGrowerPath = () => {
    if (window.location.pathname) {
      return window.location.pathname.split('/')[1] === 'grower';
    }
  };

  isGrowerUser = () => {
    return (
      JSON.parse(sessionStorage.getItem('userInfo'))?.roles?.includes(
        'GROWER'
      ) || false
    );
  };

  isGrowerMode = () => {
    return this.isGrowerPath() && this.isGrowerUser();
  };

  render() {
    const { messages, user, location, menuItems, session, sessionEmail } =
      this.props;

    const { isSiderCollapsed } = this.state;
    const notificationCount =
      user &&
      user.notifications &&
      user.notifications.filter((x) => x.is_read_completed !== true);
    const { Header } = Layout;
    const { Footer } = Layout;
    const timeout = getUserIdleTimeoutDuration(sessionEmail);
    const isInActiveGrowerWithNoCreditHistory =
      checkInactiveGrowerWithNoCreditHistory(user);
    const showNtc = verifyNotice();
    let userDetails = JSON.parse(sessionStorage.getItem('userInfo'));
    if (userDetails !== null) userDetails['showNoticeModal'] = showNtc;

    if (this.state.inactiveContact)
      return (
        <Modal
          visible
          transitionName=""
          onOk={() => {
            this.props.logoutUser();
          }}
          closable={false}
          cancelButtonProps={{ style: { display: 'none' } }}
        >
          <Result
            status="warning"
            title={messages.inactive_contact_error_title}
            subTitle={
              <div>
                {messages.inactive_contact_error_subtitle}
                <a href="mailto:support@goldenadvantage.com">
                  support@goldenadvantage.com
                </a>
              </div>
            }
          />
        </Modal>
      );

    if (isInActiveGrowerWithNoCreditHistory)
      return (
        <Modal
          visible={isInActiveGrowerWithNoCreditHistory}
          transitionName=""
          onOk={() => {
            this.props.logoutUser();
          }}
          closable={false}
          cancelButtonProps={{ style: { display: 'none' } }}
        >
          <Result
            status="warning"
            title={messages.inactive_grower_error_title}
            subTitle={
              <div>
                {messages.inactive_grower_error_subtitle}
                <a href="mailto:support@goldenadvantage.com">
                  support@goldenadvantage.com
                </a>
              </div>
            }
          />
        </Modal>
      );

    // If profile selection is needed, show ONLY the modal (block dashboard)
    if (this.state.showProfileSelectionModal) {
      return (
        <div className="profile-selection-container">
          <div className="profile-selection-header">
            <img
              src={logo}
              className="logo"
              alt="logo"
              style={{
                maxWidth: '200px',
                margin: '20px auto',
                display: 'block',
              }}
            />
          </div>
          <ProfileSelectionModal
            visible={this.state.showProfileSelectionModal}
            profiles={this.props.userProfiles}
            loading={this.props.profilesLoading}
            onSelectProfile={this.handleProfileSelection}
            defaultProfileId={this.props.defaultProfileId}
            messages={this.props.profileSelectionMessages}
          />
        </div>
      );
    }

    if (
      this.props.profilesLoading &&
      !this.state.profileSelectionChecked &&
      !readActiveProfile()
    ) {
      return (
        <div className="profile-selection-container">
          <div className="profile-selection-header">
            <img
              src={logo}
              className="logo"
              alt="logo"
              style={{
                maxWidth: '200px',
                margin: '20px auto',
                display: 'block',
              }}
            />
          </div>
          <div style={{ textAlign: 'center', padding: '50px' }}>
            <Spin size="large" />
            <p style={{ marginTop: '16px', color: '#666' }}>
              Loading your profiles...
            </p>
          </div>
        </div>
      );
    }

    return (
      <React.Fragment>
        <Spin spinning={!(session && session.accessToken) || !user}>
          <IdleTimer
            ref={(ref) => {
              this.idleTimer = ref;
            }}
            timeout={timeout}
            onAction={this.onAction}
            onIdle={this.onIdle}
            onActive={this.onActive}
            debounce={500}
          />

          <Layout className="main-container">
            <IdleTimeOutModal
              showModal={this.state.showModal}
              messages={messages}
              handleClose={this.handleClose}
              handleLogout={this.handleLogout}
            />

            <NoticeModal
              showModal={this.showNtc}
              policyClk={this.state.policyClk}
              agreeClk={this.state.agreeClk}
              messages={messages}
              handleClose={this.handleNoticeClose}
              handlepolicyClick={this.handlepolicyClick}
              handleagrrementClick={this.handleagrrementClick}
              handleLogout={this.handleLogout}
            />

            <Header className="app-header" mode="inline">
              {user && (
                <Row className="action-container">
                  <Col className="ant-col-xs-4">
                    <img src={logo} className="logo" alt="logo" />
                    {this.headerMenu()}
                  </Col>

                  <Col className="headerInfoAlignment  ant-col-xs-20">
                    <span>
                      {getEnvironmentValue(SALES_YEAR_CONFIG) && (
                        <span>
                          <FinancialYearSelector />
                        </span>
                      )}
                    </span>
                    <div
                      className="notif-container"
                      onClick={() => this.onNotificationsClick()}
                    >
                      <img
                        src={notification}
                        alt="Notification Icon"
                        className="mail"
                      />
                      <span
                        className={
                          notificationCount?.length > 0
                            ? 'message-notification badgecolor'
                            : ''
                        }
                        data-badge="2"
                      >
                        {notificationCount?.length > 0
                          ? notificationCount?.length
                          : ''}
                      </span>
                    </div>
                    {this.userMenu()}
                  </Col>
                </Row>
              )}
            </Header>

            <div
              className={classNames('toggle-collapse-ele-cnt', {
                'toggle-element-expanded-margin': !isSiderCollapsed,
                'toggle-element-collapsed-margin': isSiderCollapsed,
              })}
            >
              <Tooltip
                placement="right"
                title={isSiderCollapsed ? messages.expand : messages.collapse}
              >
                <Avatar
                  className="toggle-collapse-ele"
                  icon={isSiderCollapsed ? <RightOutlined /> : <LeftOutlined />}
                  onClick={this.toggleCollapsed}
                />
              </Tooltip>
            </div>
            <SideMenu
              className="side-menu"
              menu={messages.menu}
              currPath={get(location, 'pathname', '')}
              isSiderCollapsed={isSiderCollapsed}
              menuItems={menuItems}
            />

            <Layout className="content-layout">
              <ContentBody isSiderCollapsed={isSiderCollapsed} user={user} />
              <Footer className="footer">{this.footerContent()}</Footer>
            </Layout>
          </Layout>
        </Spin>
        <CookieConsent />
        <CookieInfo
          showModal={this.state.showCookie}
          closeCookieDetail={this.closeCookiePolicy}
          messages={messages}
        />
        <SuccessDialog
          show={this.state.showSuccessDialog}
          messages={messages}
          setShowSuccessDialog={() =>
            this.setState({ showSuccessDialog: false })
          }
        />
        <ErrorDialog
          show={this.state.showErrorDialog}
          messages={messages}
          setShowErrorDialog={() => this.setState({ showErrorDialog: false })}
        />
        <ProfileSelectionModal
          visible={this.state.showSwitchProfilesModal}
          profiles={this.props.userProfiles}
          loading={this.props.profilesLoading}
          onSelectProfile={this.handleSwitchProfileSelection}
          onCancel={this.closeSwitchProfilesModal}
          defaultProfileId={this.props.defaultProfileId}
          messages={this.props.profileSelectionMessages}
        />
      </React.Fragment>
    );
  }
}

function checkInactiveGrowerWithNoCreditHistory(user) {
  if (user) {
    const isGrowerUserType =
      !!user.userType && user.userType.toLowerCase() === 'grower';
    const isInactiveGrower = isGrowerUserType && isGrowerInactive(user);
    return !user.grower_credit_histories?.length && isInactiveGrower;
  }
  return false;
}

function verifyNotice() {
  try {
    let userDetails = JSON.parse(sessionStorage.getItem('userInfo'));
    if (
      userDetails?.is_agreements_agreed !== undefined &&
      !userDetails?.is_agreements_agreed
    ) {
      return true;
    }
  } catch (e) {
    console.log('error');
  }
  return false;
}

Landing.propTypes = {
  // Profile selection props
  userProfiles: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      accountContactId: PropTypes.string,
      accountId: PropTypes.string,
      fsapId: PropTypes.string,
      salesForceId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      toolAdmin: PropTypes.bool,
      accountName: PropTypes.string,
      accountType: PropTypes.string,
      billingAddress: PropTypes.string,
    })
  ),
  profilesLoading: PropTypes.bool,
  defaultProfileId: PropTypes.string,
  loadUserProfiles: PropTypes.func,
  onSelectProfile: PropTypes.func,
  profileSelectionMessages: PropTypes.object,
  // Existing props
  session: PropTypes.object,
  sessionEmail: PropTypes.string,
  user: PropTypes.object,
  menuItems: PropTypes.array,
  history: PropTypes.object,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
  messages: PropTypes.object,
  commonMessages: PropTypes.object,
  oktaAuth: PropTypes.object,
  setSession: PropTypes.func,
  logoutUser: PropTypes.func,
  loadUserDetail: PropTypes.func,
  setUserProfile: PropTypes.func,
  aggreeClick: PropTypes.func,
  makePayment: PropTypes.func,
  status: PropTypes.string,
  salesYear: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Landing.defaultProps = {
  userProfiles: [],
  profilesLoading: false,
  defaultProfileId: null,
};

export default Landing;
